import React, { useEffect, useRef } from 'react';
import Skeleton from "react-loading-skeleton";

const MainGuide = ({ guide, loading }) => {
    const imgRef = useRef(null);


    useEffect(() => {
        if (!guide?.image_url) return;

        const handleScroll = () => {
            const img = imgRef.current;
            if (!img) return;

            const rect = img.getBoundingClientRect();
            const offset = window.scrollY + rect.top;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const translateY = (scrollTop - offset) * 0.2; // controla o efeito

            img.style.transform = `translateY(${translateY}px)`;
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [guide]);


    return (
        <React.Fragment>
            <div className="col-xxl-9">
                <div >
                    <div className="card-body">
                        {loading ? (
                            <>
                                <div className="mb-3">
                                    <Skeleton width={140} height={10} />
                                </div>
                                <div className="text-center mb-4">
                                    <Skeleton width={100} height={10} className="mb-2" />
                                    <Skeleton width={300} height={20} className="mb-2" />
                                    <Skeleton width={200} height={10} />
                                </div>
                                <Skeleton height={200} className="mb-3" />
                                <Skeleton count={5} />
                            </>
                        ) : (
                            <>
                                <div className="text-center mb-4">
                                    <p className="text-success text-uppercase mb-2">{guide?.category?.name}</p>
                                    <h6 className="mb-2 text-info"><strong>{guide?.title}</strong></h6>
                                    <p className="text-muted mb-4">{guide?.section_title}</p>
                                </div>

                                {guide?.image_url && (
                                    <div
                                        style={{
                                            width: '100%',
                                            height: '230px',
                                            overflow: 'hidden',
                                            position: 'relative',
                                        }}
                                    >
                                        <img
                                            ref={imgRef}
                                            src={guide.image_url}
                                            alt={guide?.title || 'Imagem'}
                                            style={{
                                                width: '100%',
                                                height: 'auto',
                                                minHeight: '200px', // maior que o container
                                                objectFit: 'cover',
                                                transition: 'transform 0.2s ease-out',
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                            }}
                                        />
                                    </div>
                                )}

                                <div
                                    className="text-muted mt-4"
                                    dangerouslySetInnerHTML={{ __html: guide?.description }}
                                ></div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default MainGuide;
